import {Observable, throwError as observableThrowError} from 'rxjs';

import {tap} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from './auth.service';
import {LoginService} from '../login/login.service';
import {Location} from '@angular/common';
import {isReportingApiRequest} from '../../shared/services/pacing.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private excludeHeaderUrls = ['moments.videobyte.com', 'moments.dev.dh.videobyte.tech', 'vb-prod-logger-db-results', 'vbx-etl.s3.amazonaws.com'];

  constructor(private injector: Injector,
              private location: Location) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // do not instance authService in construction due to circular reference error
    const authService = this.injector.get(AuthService);
    const loginService = this.injector.get(LoginService);
    const token = authService.getToken();
    const url = request.url.split('/');
    //Some urls do not need header, this way we pass setHeader for them
    if (!this.excludeHeaderUrls.some(url => request.url?.includes(url))) {
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
      else if (!request.url.includes('password-recovery') && !request.url.includes('auth/okta/callback')) {
        loginService.logout(true);
      }
    }
    return next.handle(request).pipe(tap(event => {
        // all good
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if ((err.status === 401 || err.status === 403) && !isReportingApiRequest(request.url)) {
            const path = this.location.path(false);
            if (path !== '/login' && path !== '/' && path !== '') {
              loginService.logoutWithReturnUrl(path);
            } else {
              loginService.logout(true);
            }
            return observableThrowError(err);
          }
        }
      }
    ));
  }
}
